export default "__VITE_ASSET__DxrL5QGD__"